export default __webpack_public_path__ + "static/media/welcome-bg-editorial.19699535.png";